import BaseEvent from "./BaseEvent";
export default class NoteEvent extends BaseEvent {
    constructor(index) {
        super();
        this.FAKE = false;
        this.PRIORITY = 4;
        this.INDEX = index;
    }
}
